import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { FaArrowUp, FaPhone, FaHeadset } from "react-icons/fa";
import Logo from '../images/risesvg.svg';
import { Link } from 'react-router-dom';

const Navbar = () => {
  const [showPopup, setShowPopup] = useState(false);

  const togglePopup = () => {
    setShowPopup(!showPopup);
  };

  const messages = [
    "Begin your trading journey today",
    "Start Now With Demo Account"
  ];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % messages.length);
    }, 3000); // Change message every 3 seconds

    return () => clearInterval(interval);
  }, []);


  const [scrolling, setScrolling] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolling(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };
  const [isOpen, setIsOpen] = useState(false);
  const [message, setMessage] = useState("");

  // Open WhatsApp
  const handleWhatsApp = () => {
    window.open("https://wa.me/9876543210", "_blank");
  };

  // Open Email Client
  const handleEmail = () => {
    window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=enquiry@therisefx.com&su=RiseFX Support Inquiry&body=`, "_blank");
  };

  // Handle Form Submit (Redirect to Gmail)
  const handleSubmit = (e) => {
    e.preventDefault();
    const email = "enquiry@therisefx.com";
    const subject = "Support Inquiry";
    const body = encodeURIComponent(message);

    // Open Gmail Compose in New Tab
    window.open(`https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${subject}&body=${body}`, "_blank");
  };

  // -------------------------------------------------------------------navbar 2 hamburger menu-------------------------------------------------
  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".custom-hamburger");
      console.log("Scrolling:", window.scrollY); // Check if this logs on scroll

      if (navbar) {
        if (window.scrollY > 50) {
          navbar.classList.add("custom-hidden");
        } else {
          navbar.classList.remove("custom-hidden");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);


  return (
    <>
      <div className='navbar-container'>

        {/* ----------------------------------------------------navbar-1 contains button and contact details------------------------------------------------------- */}

        <div className='navbar-1'>

          <div className='navbar-child text-changing'>
            <div className='navbar-child'>
              <div className="scrolling-text-container">
                <div key={index} className="scrolling-text">
                  {messages[index]}
                </div>
              </div>
            </div>

          </div>
          <div className='navbar-child nav-btns'>
            <a href='https://panel.therisefx.com/register'>
              <button className='btn-open-account'>Open Account</button>
            </a>
            <a href='https://panel.therisefx.com/login'>
              <button className='btn-login'>Login</button>
            </a>
            <div className='downlaod-app'>
              <button className='btn-download' onClick={togglePopup}>Get App</button>
            </div>
          </div>
        </div>

        {/* ----------------------------------------------------navbar-2 contains logo and navigation links------------------------------------------------------- */}

        <div className='navbar-2'>
          <div className='navbar-child'>
            <Link to='/' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
            <img src={Logo} alt='logo' className='navbar-logo2' />
            </Link>
          </div>
          <div className='navbar-child'>
            <ul className='navbar-list'>
              <Link to='/' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
                <li className='navbar-item'>
                  Home
                </li>
              </Link>

              <Link to='/About'  onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
                <li className='navbar-item has-dropdown'>
                  About Us
                </li>
              </Link>

              <Link to='/trading'  onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
                <li className='navbar-item has-dropdown'>
                  Trading
                </li>
              </Link>

              <Link to='/platform'  onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
                <li className='navbar-item has-dropdown'>
                  Platform
                </li>
              </Link>

              <Link to='/partner'  onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
                <li className='navbar-item has-dropdown'>
                  Partner With Us
                </li>
              </Link>

              <Link to='/education'  onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
                <li className='navbar-item has-dropdown'>
                  Education
                </li>
              </Link>

              <Link to='/contact'  onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
                <li className='navbar-item has-dropdown'>
                  Contact
                </li>
              </Link>
            </ul>
          </div>

          {/* ---------------------------------------------------------navbar-2 hamburger menu------------------------------------------------------- */}
          <div className="navbar-3-hamburger custom-hamburger" onClick={() => document.querySelector('.navbar-3-mobile-menu').classList.toggle('active')}>
            <img src="/images/hamburger.png" alt="menu" />
          </div>
        </div>

        {/* ---------------------------------------------------------navbar-3 mobile menu------------------------------------------------------- */}
        <div className={`navbar-2 ${scrolling ? "navbar-3 visible" : "navbar-3"}`}>
          <div className="navbar-child">
            <Link to='/' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
            <img src={Logo} alt="logo" />
            </Link>
          </div>
          <div className="navbar-child">
            <ul className="navbar-list">
              <Link to="/" onClick={() => window.scrollTo(0, 0)}>
                <li className="navbar-item">Home</li>
              </Link>
              <Link to="/About" onClick={() => window.scrollTo(0, 0)}>
                <li className="navbar-item has-dropdown">About Us</li>
              </Link>
              <Link to="/trading" onClick={() => window.scrollTo(0, 0)}>
                <li className="navbar-item has-dropdown">Trading</li>
              </Link>
              <Link to="/platform" onClick={() => window.scrollTo(0, 0)}>
                <li className="navbar-item has-dropdown">Platform</li>
              </Link>
              <Link to="/partner" onClick={() => window.scrollTo(0, 0)}>
                <li className="navbar-item has-dropdown">Partner With Us</li>
              </Link>
              <Link to="/education" onClick={() => window.scrollTo(0, 0)}>
                <li className="navbar-item has-dropdown">Education</li>
              </Link>
              <Link to="/contact" onClick={() => window.scrollTo(0, 0)}>
                <li className="navbar-item has-dropdown">Contact</li>
              </Link>
            </ul>
          </div>

          {/* Hamburger Menu */}
          <div className="navbar-3-hamburger" onClick={toggleMenu}>
            <img src='/images/hamburger.png' alt="menu" />
          </div>

          {/* Mobile Navigation (Toggled by Hamburger) */}
          <div className={`navbar-3-mobile-menu ${menuOpen ? "active" : ""}`}>
            <ul>
              <Link to="/" onClick={(e) => { toggleMenu(); window.scrollTo(0, 0); }} >
                <li>Home</li>
              </Link>
              <Link to="/About" onClick={(e) => { toggleMenu(); window.scrollTo(0, 0); }} >
                <li>About Us</li>
              </Link>
              <Link to="/trading" onClick={(e) => { toggleMenu(); window.scrollTo(0, 0); }} >
                <li>Trading</li>
              </Link>
              <Link to="/platform" onClick={(e) => { toggleMenu(); window.scrollTo(0, 0); }} >
                <li>Platform</li>
              </Link>
              <Link to="/partner" onClick={(e) => { toggleMenu(); window.scrollTo(0, 0); }} >
                <li>Partner With Us</li>
              </Link>
              <Link to="/education" onClick={(e) => { toggleMenu(); window.scrollTo(0, 0); }} >
                <li>Education</li>
              </Link>
              <Link to="/contact" onClick={(e) => { toggleMenu(); window.scrollTo(0, 0); }} >
                <li>Contact</li>
              </Link>
              <li>
                <a  onClick={(e) => { toggleMenu(); togglePopup(); window.scrollTo(0, 0); }} >Download</a>
              </li>
            </ul>
          </div>
        </div>


        <div className='mobile-icon'>
          <Link to='/' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
            <img src='/images/home-icon.svg' alt='error' />
            Home
          </Link>
          <Link to='/About' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
            <img src='/images/about-icon.svg' alt='error' />
            About
          </Link>
          <Link to='/trading' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
            <img src='/images/services-icon.svg' alt='error' />
            Trading
          </Link>
          <Link to='/partner' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
            <img src='/images/partner.svg' alt='error' />
            Partner
          </Link>
          <Link to='/contact' onClick={() => window.scrollTo(0, 0, { behavior: 'smooth' })}>
            <img src='/images/contact-icon.svg' alt='error' />
            Contact
          </Link>
        </div>


        {showPopup && (
          <div className='popup'>
            <button className='close-btn' onClick={togglePopup}>X</button>
            <div className='popup-content'>
              <img src='/images/QRcode1.png' alt='QR Code 1' className='qr-img' />
              <a href='https://panel.therisefx.com/platform/TheRiseFX-1.0.apk'>
                <img src='images/android-download.png' className='download-icon' alt='error' />
              </a>
            </div>
            <div className='popup-content'>
              <img src='/images/QRcode2.png' alt='QR Code 2' className='qr-img' />
              <a href='https://apps.apple.com/us/app/mobiustrader-7/id1355359598'>
                <img src='images/ios-download.png' className='download-icon' alt='error' />
              </a>
            </div>
          </div>
        )}
      </div>


      <div className='back-to-top'>
        <button className='scroll-to-top' onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
          <FaArrowUp />
        </button>
      </div>
      <div className="support-container">
        {/* Floating Support Button */}
        <button className="support-button" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaArrowUp size={22} /> : <FaHeadset size={22} />}
        </button>

        {/* Popup Box */}
        {isOpen && (
          <div className="support-popup">
            <h3 className="support-title">Need Help?</h3>

            {/* WhatsApp & Email Buttons */}
            <div className="support-buttons">
              <button className="support-email" onClick={handleEmail}>
                <FaHeadset size={18} />
                Email
              </button>
            </div>

            {/* Form Section */}
            <form className="support-form" onSubmit={handleSubmit}>
              <label className="support-label">Drop your message:</label>
              <textarea
                className="support-textarea"
                placeholder="Enter your message..."
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                required
              ></textarea>
              <button className="support-submit" type="submit">
                <FaArrowUp size={16} />
                Send Message
              </button>
            </form>
          </div>
        )}
      </div>
    </>
  );
}

export default Navbar;
